  <div>
    <a href="https://alpura.com/" target="_blank">Alpura</a>
    <span> &copy; 2023</span>
  </div>
  <!-- <div class="ms-auto">
    Powered by
    <a href="https://kernel-technologies.com" target="_blank">
      <span> Kernel Technologies</span>
    </a>
  </div> -->
